export const STATE_LANDING_PAGE: string = "State_Landing";
export const STATE_MENU: string = "State_Menu";
export const STATE_GAME: string = "State_Game";
export const STATE_PLAYBACK: string = "State_Playback";
export const LOAD_INTERSTITIAL: string = "Load_Interstitial";
export const POPUP_MUSIC_SHARE: string = "Popup_Music_Share";
export const AUDIO_CATEGORY_SOLO: string = "AudioCategorySolo";

export const SPRITESHEET_UI: string[] = ["ui-1"];
export const FONT_GEL_MED_35: string = "gelPenMedium35";

export const TWEEN_ONCOMPLETE: string = "onComplete";
export const TWEEN_ONUPDATE: string = "onUpdate";

export const DEBUG_DEFAULT_STATE: string | undefined = undefined;
export const NO_LOOP = -1;
export const SCENE_WIDTH = 1664;
export const SCENE_HEIGHT = 768;
